// フォームのデフォルト値定義
export const getDefaultFormValues = () => ({
  // ステップ1のプロジェクト基本情報
  name: '',
  period_from: '',
  period_at: '',
  participation_flag: false,
  development_methods: [],
  sprint_cycle_week: '',
  role_ids: [],
  project_scale: '',
  team_scale: '',
  industry_ids: [],
  achievement: '',

  // ステップ2-7の要件定義から運用/保守まで
  requirements_definition_operations: [{ operation_id: '', content: '' }],
  basic_design_operations: [{ operation_id: '', content: '' }],
  detail_design_operations: [{ operation_id: '', content: '' }],
  program_operations: [{ operation_id: '', content: '' }],
  test_operations: [{ operation_id: '', content: '' }],
  maintenance_operations: [{ operation_id: '', content: '' }],

  // ステップ8-9のフロントエンド・バックエンド
  frontend_languages: [{ language_name: '', language_id: '', fw_library_name: '', fw_library_id: '' }],
  backend_languages: [{ language_name: '', language_id: '', fw_library_name: '', fw_library_id: '' }],

  // ステップ10-12の業務システム・クラウド・サーバーOS
  business_systems: [{ business_system_name: '', business_system_id: '', business_system_product_language_name: '', business_system_product_language_id: '' }],
  cloud_services: [{ cloud_service_name: '', cloud_service_id: '', cloud_service_product_name: '', cloud_service_product_id: '' }],
  server_operating_systems: [{ server_operating_system_name: '', server_operating_system_id: '', server_environment_name: '', server_environment_id: '' }],

  // ステップ13-18のその他のツール・技術
  operating_systems: [{ operating_system_name: '', operating_system_id: '' }],
  middlewares: [{ middleware_name: '', middleware_id: '', middleware_product_name: '', middleware_product_id: '' }],
  dbs: [{ db_name: '', db_id: '' }],
  networks: [{ network_name: '', network_id: '' }],
  design_tools: [{ design_tool_name: '', design_tool_id: '' }],
  tools: [{ tool_name: '', tool_id: '' }],
  selectedTools: [],
  selectedOperatingSystems: [],
  selectedMiddlewares: [],
  selectedDbs: [],
  selectedNetworks: [],
  selectedDesignTools: []
});

// マスタデータの初期状態
export const getInitialMasterData = () => ({
  development_methods: [],
  sprint_cycle_week: '',
  roles: [],
  industries: [],
  requirements_definition_operations: [],
  basic_design_operations: [],
  detail_design_operations: [],
  program_operations: [],
  test_operations: [],
  maintenance_operations: [],
  languages: [],
  fw_libraries: [],
  business_systems: [],
  business_system_product_languages: [],
  cloud_services: [],
  cloud_service_products: [],
  server_operating_systems: [],
  server_environments: [],
  operating_systems: [],
  middlewares: [],
  dbs: [],
  networks: [],
  design_tools: [],
  tools: []
});
